import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  useGetQualificationSchemeCompetitionsQuery,
  type QualificationSchemeCompetitionDto,
} from "../../../../../../autogen/bff-api";

export const SchemeCompetitionInvitees = ({ competition }: { competition: QualificationSchemeCompetitionDto }) => {
  const { t } = useTranslation();
  const invited = competition.invitedOrganizationIds ?? [];
  const narrowed = invited.length > 0;
  const { data } = useGetQualificationSchemeCompetitionsQuery(
    { eventId: competition.schemeId },
    { skip: !narrowed },
  );

  if (!narrowed) return <Text>{t("All qualified suppliers are invited")}</Text>;

  const admitted = data?.admittedSuppliers?.map((supplier) => supplier.organizationId);
  return (
    <Box>
      <Text>
        {admitted
          ? t("{{invited}} of {{admitted}} qualified suppliers are invited", {
              invited: invited.filter((id) => admitted.includes(id)).length,
              admitted: admitted.length,
            })
          : t("{{count}} selected qualified suppliers are invited", { count: invited.length })}
      </Text>
      {competition.narrowingReason && (
        <Text mt="1" fontSize="sm" color="smMuted" whiteSpace="pre-wrap">
          {competition.narrowingReason}
        </Text>
      )}
    </Box>
  );
};
